import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  PromoCodeFlowResponse,
  PromoCodeRedeemDto,
  PromoCodeRedemption,
  PromoCodeRedemptionListResponse
} from '@zerops/models/promo-code';

@Injectable({ providedIn: 'root' })
export class PromoCodeBaseApi {
  #http = inject(HttpClient);

  redemptions$(clientId: string) {
    return this.#http.get<PromoCodeRedemptionListResponse>(
      `/api/billing/client/${clientId}/promo-code`
    );
  }

  // Unauthenticated on purpose, so a deep link can ask before there is a
  // session. It answers for any string and never says whether a code exists —
  // an unknown one comes back `VERIFIED` with a 200.
  flow$(code: string) {
    return this.#http.get<PromoCodeFlowResponse>(
      `/api/promo-code/${encodeURIComponent(code)}/flow`
    );
  }

  redeem$(clientId: string, data: PromoCodeRedeemDto) {
    return this.#http.post<PromoCodeRedemption>(
      `/api/billing/client/${clientId}/promo-code`,
      data
    );
  }
}
